export default __webpack_public_path__ + "static/media/sasuke.aef2ff91.png";